<template lang="pug">
  div.upper-subpanel--inside
    Loader(v-if="getComboMed === false")
    div.combomed-list-wrapper(v-else)
      div.med-list
        div(v-if="comboMedSet.length === 0" style="display: flex; justify-content: center; align-items: center; height: 100%")
          h5 未設定藥物組合
        div(v-else)
          div.combomed-button(
            v-for="med, index in comboMedSet"
            :class="{ 'combomed-button-selected': med.selected, 'unselectable': med.amountInSystem === 0, 'fetched-button': med.fetched }")
            div.combomed-detail(@click="selectMed(med)")
              div#fetch_status(:class="{ 'fetched': med.fetched }") {{ med.fetched | fetchZh }}
              div#med_info 
                h6 {{ med.child_medication.code }} - {{med.child_medication.CGMH_number}}
                span
                  small {{ med.child_medication.generic_name }} 
                  small(v-if="med.child_medication.product_name") {{ med.child_medication.product_name }}
              div
                //- p#status
                //-   span 存量狀態
                //-   span(v-if="med.amountInSystem === 0") 無存量
                //-   span(v-else="med.amountInSystem > 0") 存量正常
                p#combo-name(v-if="med.parent_medication.type === 'combo'")
                  span 套藥
                  span {{ med.parent_medication.generic_name }}
                
                p#remain_amount 
                  span 系統存量
                  span {{ med.amountInSystem }}
                p#dose(v-if="med.child_medication_dose")
                  span 用藥劑量
                  span {{ med.child_medication_dose }}
                    span(v-if="med.child_medication_dose_unit") {{ med.child_medication_dose_unit }} 
                p#dose(v-if="med.child_medication_quantity")
                  span 取藥數量
                  span {{ med.child_medication_quantity }} 
                    span(v-if="med.child_medication_quantity_unit") {{ med.child_medication_quantity_unit}}
            //- div.drug-in-system(v-if="med.child_medication.restrained_class === 0")
            //-   div.amount-button-wrapper
            //-     div#add.amount-button(@click="addAmount(med, index)")
            //-       font-awesome-icon(:icon="upIcon" style="color: white; width: 25px")
            //-     div#minus.amount-button(@click="minusAmount(med, index)")
            //-       font-awesome-icon(:icon="downIcon" style="color: white; width: 25px")
          
          
            
          div(v-if="otherFetchEvents.length > 0")
            div.combomed-button.other-fetch-events(v-for="event in otherFetchEvents")
              div.combomed-detail
                div#fetch_status(v-if="event.related_events.length === 0" style="background-color: green; color: white") 已取藥
                div#fetch_status(v-else style="background-color: red; color: white") 
                  div(v-for="e in event.related_events") {{ e.event_type.event_name | zhLabel }}
                div#med_info  
                  h6 {{ event.medication.code }} - {{ event.medication.CGMH_number}}
                  span 
                    small {{ event.medication_generic_name }}
                div
                  p#dose 
                    span 數量
                    span {{ Math.abs(event.number1) }}
              
          
        //- div.total-med
        //-   h5.text-center 已選藥物
        //-   ul
        //-     li.combo-med-selected(v-for="med, medId in drugsForFetch")
        //-       span {{ med.med.generic_name }} - {{ med.amount }}
    div.fake-bottom-buttons
      action-button(title="選擇全部" @click.native="selectAllMed(true)")
      action-button(title="取消選擇" @click.native="selectAllMed(false)")
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
// import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Loader from '../common/Loader';


export default {
  name: 'ComboMedListAndPatient',
  props: {
    filterOutZeroAmountMed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getComboMed: false,
      otherFetchEvents: [],
    };
  },
  components: {
    Loader,
  },
  async created() {
    await this.$store.dispatch('getComboMedSet');
    await this.checkMedFetched();
    this.getComboMed = true;
    this.$store.commit('SET_CURRENT_STEP', 'selectMeds');
  },
  methods: {
    checkMedFetched() {
      return this.instance.get('/api/event/', {
        params: {
          number2: this.currentSchedule.id,
          event: 'FETCH',
        },
      })
      .then((res) => {
        this.otherFetchEvents = [];
        res.data.results.forEach((item) => {
          const target = _.find(this.comboMedSet, (s) => { return s.child_medication.id === item.medication.id; });
          if (target) {
            target.fetched = true;
          } else {
            this.otherFetchEvents.push(item);
          }
        });
      });
    },
    selectMed(med) {
      this.$store.dispatch('selectComboMed', {
        med: med.child_medication,
        dose: med.child_medication_dose,
        doseUnit: med.child_medication_dose_unit,
        amount: med.child_medication_quantity,
        select: !med.selected,
        drugInDevice: med.drugInDevice,
      });
    },
    selectAllMed(selectStatus) {
      this.comboMedSet.forEach((med) => {
        if (med.amountInSystem !== 0) {
          this.$store.dispatch('selectComboMed', {
            med: med.child_medication,
            dose: med.child_medication_dose,
            doseUnit: med.child_medication_dose_unit,
            amount: med.child_medication_quantity,
            select: selectStatus,
            drugInDevice: med.drugInDevice,
          });
        }
      });
    },
    addAmount(med, index) {
      this.comboMedSet[index].child_medication_quantity += 1;
      this.$store.dispatch('selectComboMed', {
        med: med.child_medication,
        dose: this.comboMedSet[index].child_medication_dose,
        doseUnit: this.comboMedSet[index].child_medication_dose_unit,
        amount: this.comboMedSet[index].child_medication_quantity,
        select: true,
        drugInDevice: med.drugInDevice,
      });
    },
    minusAmount(med, index) {
      if (this.comboMedSet[index].child_medication_quantity > 0) {
        this.comboMedSet[index].child_medication_quantity -= 1;
        this.$store.dispatch('selectComboMed', {
          med: med.child_medication,
          dose: this.comboMedSet[index].child_medication_dose,
          doseUnit: this.comboMedSet[index].child_medication_dose_unit,
          amount: this.comboMedSet[index].child_medication_quantity,
          select: true,
        });
      }
    },
    printQR() {
      this.$store.dispatch('printQR');
    },
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
    comboMedSet() {
      if (this.filterOutZeroAmountMed) {
        return this.$store.getters.comboMedSet.filter(item => item.amountInSystem > 0);
      }
      return this.$store.getters.comboMedSet;
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    drugsForFetch() {
      return this.$store.getters.drugsForFetch;
    },
  },
  filters: {
    timeOnly(val) {
      return moment(val).format('HH:mm');
    },
    fetchZh(val) {
      if (val) {
        return '已取藥';
      }
      return '未取藥';
    },
    zhLabel(value) {
      if (value === 'WASTE') return '已拋棄';
      if (value === 'RETURN_EMPTY') return '已退空瓶';
      if (value === 'RETURN') return '已退藥';
      return value;
    },
  },
};
</script>

<style lang="sass">
.combomed-list-wrapper
  margin: 0
  height: 100%
  width: 100%
  display: flex
  .med-list
    width: 100%
    overflow-y: auto
    &::-webkit-scrollbar-track
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
      background-color: #F5F5F5;
    &::-webkit-scrollbar
      width: 6px;
      background-color: #F5F5F5;  
    &::-webkit-scrollbar-thumb
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      background-color: #555;
  .patient-total-med-wrapper
    width: 25%

.combo-med-selected
  padding: 10px
  text-align: center

.patient-total-med-wrapper
  height: 100%
  .total-med
    height: calc(100% - 95px)
    margin: 10px;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    h5
      background: cadetblue;
      margin: -10px;
      padding: 10px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      color: white;
.combomed-button
  margin: 5px 5px
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  // border: 1px solid transparent
  background-color: #f4f4f4
  border-color: #dbdbdb
  display: flex;
  justify-content: space-between;
  transition: all ease 0.3s
  .combomed-detail
    width: 100%
    padding: 5px
    display: flex
    justify-content: space-between
    position: relative
    *
      margin: 0
    p
      display: inline-flex
      flex-direction: column
      min-width: 80px
      padding: 0 1rem
      text-align: center
      font-size: 12px
      border-left: 1px solid rgba(0,0,0,.3)
    #dose, #remain_amount, #combo-name, #qty
      span
        &:nth-child(2)
          font-size: 20px
    
    #med_info
      margin-left: 32px
      display: flex;
      font-size: 16px;
      flex-direction: column;
      justify-content: center;
    #fetch_status
      justify-content: center;
      align-items: center;
      writing-mode: vertical-lr;
      display: flex;
      background-color: yellow
      border-radius: 5px
      color: black
      position: absolute
    .fetched
      color: white
      background-color: green !important
  .amount-button-wrapper
    height: 100%
    .amount-button
      height: 100%
      width: 75px
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: white
      font-size: 40px
      &#add
        background-color: steelblue
      &#minus
        background-color: lighten(red, 10%)
        margin-right: 0
      &:active
        background-color: rgba(0,0,0,0.3) !important;

.combomed-button-selected
  background-color: slategrey;
  color: white;

.unselectable
  pointer-events: none;
  box-shadow: none;
  border-style: unset
  color: rgba(0,0,0,0.3)
  .amount-button
    background-color: rgba(0,0,0,0.3) !important
  #remain_amount
    color: red

.fetched-button
  #remain_amount
    color: rgba(0,0,0,0.3)


.fake-bottom-buttons
  position: absolute;
  bottom: -98px;
  right: 188px;
  width: 198px;
  display: flex;
  justify-content: space-between;

.other-fetch-events
  border: 1px dashed gray;
  border-radius: 6px;
  color: cadetblue;
  box-shadow: none;
  background-color: white
</style>



// WEBPACK FOOTER //
// ComboMedListAndPatient.vue?4145f538